<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal
      :title="internship_form.id ? 'Update LIA' : 'Create LIA'"
      :subtitle="'Fill in the information below'"
      btnlefttext="Save Changes"
      btncentertext="Cancel"
      btnrighttext="Add Multiple LIA"
      :leftloading="internship_loading"
      :rightloading="false"
      :centerloading="false"
      :footerhidden="false"
      footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px"
      body_padding="0px 30px"
      width="550px"
      :hiderightbtn="true"
      @onLeftClick="onConfirm()"
      @onCenterClick="onCancel"
      @onRightClick="onRightClick()"
    >
      <div class="widget-modal-body-noscoll">
        <div class="form-divider">LIA information</div>
        <widgetInputWrapper title="LIA Title">
          <widgetInput
            type="text"
            v-model="internship_form.name"
            placeholder=""
          ></widgetInput>
        </widgetInputWrapper>

        <div class="row">
          <widgetInputWrapper title="Time frame">
            <widgetDatePicker
              left_input_placeholder="From"
              right_input_placeholder="To"
              v-model="internship_date"
              :left_input_disabled="false"
              :right_input_disabled="false"
              :left_input_disabled_dates="{}"
              :right_input_disabled_dates="{}"
            ></widgetDatePicker>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper title="Location">
            <map-helper
              :isMultiple="true"
              v-model="internship_form.location"
            ></map-helper>
          </widgetInputWrapper>
        </div>

        <widgetInputWrapper title="Tags">
          <widgetTags
            v-model="tags"
            :input_width="'100%'"
            placeholder="Add tags"
          ></widgetTags>
        </widgetInputWrapper>
        <widgetInputWrapper title="Description">
          <widgetTextarea
            v-model="internship_form.description"
            placeholder=""
          ></widgetTextarea>
        </widgetInputWrapper>

        <div class="form-divider">Company information</div>
        <widgetInputWrapper title="Company name">
          <widgetInput
            type="text"
            v-model="internship_form.company_name"
            placeholder=""
          ></widgetInput>
        </widgetInputWrapper>

        <div class="row">
          <widgetInputWrapper title="First name">
            <widgetInput
              type="text"
              v-model="internship_form.first_name"
              placeholder=""
            ></widgetInput>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper title="Last name">
            <widgetInput
              type="text"
              v-model="internship_form.last_name"
              placeholder=""
            ></widgetInput>
          </widgetInputWrapper>
        </div>

        <div class="row">
          <widgetInputWrapper title="Email">
            <widgetInput
              type="text"
              v-model="internship_form.email"
              placeholder=""
            ></widgetInput>
          </widgetInputWrapper>
          <div class="h-spacer"></div>
          <widgetInputWrapper title="Phone">
            <widgetInput
              type="text"
              v-model="internship_form.phone"
              placeholder=""
            ></widgetInput>
          </widgetInputWrapper>
        </div>
      </div>
    </widgetModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internship_form: {
        id: null,
        from: "",
        to: "",
        name: "",
        token: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        company_name: "",
        company_contact: "",
        location: [],
        description: "",
        tags: [],
        tags_added: [],
        tags_removed: [],
      },
      tags: {
        added: [],
        removed: [],
      },
      internship_date: { from: new Date(), to: new Date() },
      internship_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    if (vm.content) {
      vm.setContent(vm.content);
    } else {
      vm.addNew();
    }
  },
  methods: {
    setContent(item) {
      let vm = this;
      vm.internship_form.id = item.id;
      vm.internship_form.name = item.name;
      // Check is location is array
      if (Array.isArray(item.location)) {
        vm.internship_form.location = item.location;
      } else {
        vm.internship_form.location = [];
      }
      vm.internship_form.description = item.description;
      vm.tags = {
        added: [],
        removed: [],
      };
      if (item.tags) {
        item.tags.forEach((item) => {
          eventBus.$set(item, "on_update", true);
          vm.tags.added.push(item);
        });
      }
      vm.internship_date = {
        from:
          item.from && item.from != "0000-00-00 00:00:00"
            ? vm.moment(item.from).toDate()
            : "",
        to:
          item.to && item.to != "0000-00-00 00:00:00"
            ? vm.moment(item.to).toDate()
            : "",
      };

      vm.internship_form.from = item.from;
      vm.internship_form.to = item.to;
      vm.internship_form.company_name = item.company_name;
      vm.internship_form.company_contact = item.company_contact;
      vm.internship_form.first_name = item.first_name;
      vm.internship_form.last_name = item.last_name;
      vm.internship_form.email = item.email;
      vm.internship_form.phone = item.phone;
    },
    addNew() {
      let vm = this;
      vm.tags = {
        added: [],
        removed: [],
      };
      vm.internship_form = {
        id: null,
        from: "",
        to: "",
        name: "",
        token: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        company_name: "",
        company_contact: "",
        location: [],
        description: "",
        tags: [],
        tags_added: [],
        tags_removed: [],
      };
    },
    onRightClick() {
      let vm = this;
      vm.internship_form.save_type = "many";
    },
    onConfirm() {
      let vm = this;
      vm.internship_form.from = vm
        .moment(vm.internship_date.from)
        .format("YYYY-MM-DD HH:mm:ss");
      vm.internship_form.to = vm
        .moment(vm.internship_date.to)
        .format("YYYY-MM-DD HH:mm:ss");
      vm.internship_form.tags = vm.tags.added.map((item) => {
        return item;
      });

      const rules = {
        name: {
          run: (value) => {
            if (value && value.length > 0) {
              return false;
            }
            if (vm.internship_form.save_type == "single" && vm.type != "gen") {
              return "LIA title can not be empty";
            } else {
              return false;
            }
          },
        },
        company_name: {
          run: (value) => {
            if (!value) {
              return "Company name can not be empty";
            }
            return false;
          },
        },
        location: {
          run: (value) => {
            if (!value) {
              return "Location can not be empty";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.internship_form, rules)) {
        vm.internship_loading = true;
        if (!vm.internship_form.id) {
          vm.$store
            .dispatch("INTERNSHIP_SAVE_PRIVATE_INTERNSHIP", vm.internship_form)
            .then((responce) => {
              vm.internship_loading = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "LIA is now added",
                type: "success",
                duration: 3000,
              });
              vm.$emit("success", responce.data);
            })
            .catch((error) => {
              vm.internship_loading = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: error.response.data.message,
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          vm.$store
            .dispatch(
              "INTERNSHIP_UPDATE_PRIVATE_INTERNSHIP",
              vm.internship_form
            )
            .then((responce) => {
              vm.internship_loading = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "LIA is now updated",
                type: "success",
                duration: 3000,
              });
              vm.$emit("success", responce.data);
            })
            .catch((error) => {
              vm.internship_loading = false;
              vm.$notify({
                group: "status",
                title: "Message",
                text: "LIA is not updated",
                type: "warn",
                duration: 3000,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.page-modal {
  .widget-modal-body-noscoll {
    .form-divider {
      margin-top: 10px;
      padding: 10px 0px;
      border-bottom: 1px solid #e5e5e5;
      font-weight: 600;
    }
  }
}
</style>